import {booleanToYesNo, segment} from './helpers'

/**
 * Fired upon first viewing Lookbuilder
 */
export const viewedLookbuilder = () => segment('Viewed Lookbuilder')

/**
 * Used to measure user intention for saving a look and ascertaining which products
 * are most popular for future enhancements.
 *
 * @param {Object} productsByCategory Object with category keys and product name values
 */
export const clickedLookbuilderSaveLink = (productsByCategory) =>
  segment('Clicked Lookbuilder Save Link', {...productsByCategory})

/**
 * Fires when a look is successfully added via Lookbuilder
 * @todo Remove this event once the Optimizely experiment is over
 */
export const createdLookbuilderLook = () => segment('Created Lookbuilder Look')

/**
 * Measures the rate at which users add new products to their Planner View. Includes
 * a property to give insight into how many times a user is replacing an existing
 * item.
 *
 * @param {String} name The name of the product
 * @param {String} productCategory The name of the Lookbuilder category the product is added to
 * @param {Boolean} [swap] Whether the product is replacing an existing product or not
 */
export const addedProductToLookbuilder = (name, productCategory, swap = false) =>
  segment('Added Product to Lookbuilder', {name, productCategory, swap: booleanToYesNo(swap)})

/**
 * Signals when a user removes a product from their Lookbuilder look
 * @param {String} name The name of the product
 * @param {String} productCategory The Lookbuilder category the product was removed from
 * @param {String} origin Describes how the user initiated this action
 */
export const removedProductFromLookbuilder = (name, productCategory, origin) =>
  segment('Removed Product from Lookbuilder', {name, productCategory, origin})

/**
 * Fires when user clicks the "Review My Saved Looks" button
 */
export const reviewedSavedLooks = () => segment('Clicked Review Saved Looks')

/**
 * Fires when user clicks the "Copy items for X look" button
 */
export const copiedLookbuilderLook = () => segment('Clicked Copy Lookbuilder Look')
